import { render, staticRenderFns } from "./OrderDetailTradeIn.vue?vue&type=template&id=16e83a16&scoped=true"
import script from "./OrderDetailTradeIn.vue?vue&type=script&lang=js"
export * from "./OrderDetailTradeIn.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTradeIn.vue?vue&type=style&index=0&id=16e83a16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e83a16",
  null
  
)

export default component.exports